import KeycloakIFrame from "./components/KeycloakIFrame.vue";
import Beacon from "./components/Beacon.vue";
import store from "./store";
import { UserRoleGuard } from "./router";

export { Beacon, KeycloakIFrame, store, UserRoleGuard };
